import {useEffect, useReducer} from "react";
import {FrmVar} from "../drawfrm/FrmVar";

// react binding for FrmVar: re-renders on every change and returns the current
// value. Mirrors useEventEmitter2, but FrmVar is not an EventEmitter2 (its
// subscribe returns a Subscription with cancel(), and emits a change event rather
// than the value), so it needs its own hook.
export function useFrmVar(v: FrmVar): number {
    const [, forceRender] = useReducer((x: number) => x + 1, 0);

    useEffect(() => {
        const sub = v.subscribe(() => forceRender());
        return () => sub.cancel();
    }, [v]);

    return v.get();
}
